import React, { FC } from 'react';
import { Box, Link, useMediaQuery, useTheme } from '@mui/material';
import { useStyles } from './AboutMenu.styles';
import { LinkOption } from 'app/interfaces';
import { LINKS } from 'shared/constants';

export const AboutMenu: FC = () => {
  const theme = useTheme();
  const { classes } = useStyles();
  const isFullScreen = useMediaQuery(theme.breakpoints.up('lg'));

  if (!isFullScreen) {
    return null;
  }

  return (
    <Box>
      {LINKS.map((link: LinkOption) => (
        <Box className={classes.links} key={link.label}>
          <Box className={classes.icon}>{React.createElement(link.icon)}</Box>
          <Link
            className={classes.link}
            href={link.href}
            underline="hover"
            rel="noreferrer"
            target="_blank"
          >
            {link.label}
          </Link>
        </Box>
      ))}
    </Box>
  );
};
